// @flow

import React from 'react';
import ClassNames from 'classnames';

import { quizPageCls, quizPageVerticalCls, quizPageActiveCls } from './Page.less';

type Props = {
  isActive: boolean,
  className: ?string,
  children?: React$Element<*>,
};

export { quizPageVerticalCls };

/**
 * QuizPage
 *
 * @param {Props} props
 */
export const QuizPage = ({
  isActive = false,
  className,
  children = null,
}: Props): React$Element<*> => (
  <section
    className={ClassNames(quizPageCls, className, {
      [quizPageActiveCls]: isActive,
    })}
  >
    {children}
  </section>
);
